export default __webpack_public_path__ + "static/media/plus.fd4943b0.svg";